<template>
  <div v-if="modalOpen==true">
    <div class="fixed z-50 inset-0 overflow-y-auto">
      <div
        class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
      >
        <!--
      Background overlay, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0"
        To: "opacity-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100"
        To: "opacity-0"
    -->
        <div
          class="fixed inset-0 transition-opacity"
          aria-hidden="true"
          @click="$emit('close')"
          
        >
          <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span
          class="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
          >&#8203;</span
        >
        <!--
      Modal panel, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        To: "opacity-100 translate-y-0 sm:scale-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100 translate-y-0 sm:scale-100"
        To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    -->
        <div
          class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-headline"
        >
          <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div class="sm:flex sm:items-start">
              
              <div
                class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10"
              >
                <!-- Heroicon name: exclamation -->


                <svg-icon icon="heroicons/outline/exclamation" class="h-6 w-6 text-red-600"> </svg-icon>
              </div>

              <div class="mt-3 sm:mt-0 text-center sm:ml-4 sm:text-left">
                <h3
                  class="text-lg leading-6 font-medium font-semibold text-gray-900"
                  id="modal-headline"
                >
                  <slot name="header">
                    Are you sure?
                  </slot>
                </h3>

                <div class="mt-2">
                  <slot name="body">
                    <p class="text-sm text-gray-500">
                      Are you sure you wish to continue? This action cannot
                      be undone.
                    </p>
                  </slot>
                </div>


              </div>
            </div>
          </div>

          <div class="bg-gray-200 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <button
              type="button"
              class="m-0 w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
              @click="$emit('confirm')"
            >
              Confirm
            </button>
            <button
              type="button"
              style="border: 1px solid rgb(196 196 196);"
              class="mt-3 sm:mt-0 w-full inline-flex justify-center rounded-md  shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:ml-3 sm:w-auto sm:text-sm"
             @click="$emit('close')"
            >
              Cancel
            </button>
          </div>

        </div>


      </div>
    </div>
  </div>
</template>

<script>
import SvgIcon from './SvgIcon.vue';
export default {
  components: { SvgIcon },
  name: "base-modal",
  props: ["showModal"],
  data: function(){
    return {

    }
  },
  computed: {
      modalOpen(){ 
        return this.showModal} 
  }
};
</script>
